var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 27,
    viewBox: "0 0 21 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.612 0L10.5004 2.57408L5.38867 0L10.5004 9.74774L15.612 0Z",
    fill: "#FDB913"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4218 7.74565L17.3436 7.67934L20.988 6.14213V1L14.6375 3.71876L11.1254 10.386C12.424 10.5371 13.6217 11.1619 14.4901 12.1414C15.3586 13.1209 15.837 14.3865 15.8342 15.697C15.8342 17.1146 15.2732 18.4744 14.2743 19.4779C13.2754 20.4815 11.9202 21.0469 10.506 21.0501C9.09124 21.0469 7.73539 20.4817 6.73555 19.4783C5.73571 18.4749 5.17341 17.1152 5.17182 15.697C5.17034 14.3869 5.64922 13.122 6.51741 12.1428C7.3856 11.1635 8.58254 10.5383 9.88058 10.386L6.37457 3.71876L0.036081 1.01206V6.15419L3.68643 7.6914L3.60825 7.75771C2.47615 8.74604 1.56835 9.96597 0.945961 11.3354C0.323569 12.7049 0.00101421 14.1921 0 15.697C0.0031833 18.4875 1.11045 21.1628 3.07889 23.136C5.04733 25.1092 7.7162 26.2192 10.5 26.2223C13.2838 26.2192 15.9527 25.1092 17.9211 23.136C19.8895 21.1628 20.9968 18.4875 21 15.697C21.0029 14.1926 20.6852 12.705 20.0681 11.3337C19.451 9.96243 18.5488 8.73911 17.4218 7.74565Z",
    fill: "#FDB913"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNh);
export default __webpack_public_path__ + "static/media/nh.6ce94fe211126ea9a34f3df180c6caa6.svg";
export { ForwardRef as ReactComponent };